import type { SERVICE_TYPE } from './service.types';

export enum InvoiceType {
  INVOICE = 'INVOICE',
  PREPAID = 'PREPAID',
  ZERO_BALANCE_INVOICE = 'ZERO_BALANCE_INVOICE',
}

export enum AgingBracket {
  LESS_THAN_30 = 'LESS_THAN_30',
  DAY_30 = '30_DAY',
  DAY_60 = '60_DAY',
  DAY_90 = '90_DAY',
}

export enum ARInvoiceStatus {
  PAID = 'PAID',
  UNPAID = 'UNPAID',
}

export interface AccountsReceivableQueryParams {
  clientIds?: string[];
  invoiceNumbers?: string[];
  fileNumbers?: string[];
  invoiceType?: InvoiceType;
  status?: ARInvoiceStatus;
  agingBracket?: AgingBracket;
  fromDate?: string;
  toDate?: string;
  sortField?: 'clientId' | 'billingDate' | 'invoiceNumber' | 'fileNo' | 'invoiceAmount';
  sortDirection?: 'asc' | 'desc';
  pageNo?: number;
  pageSize?: number;
}

export interface AgingInfo {
  daysOverdue: number;
  bracket?: AgingBracket;
}

export interface AccountsReceivableInvoice {
  clientId: string;
  clientName?: string | null;
  billingDate: Date;
  invoiceNumber: string;
  workOrderId: string | null;
  fileNo?: string | null;
  invoiceAmount: number;
  invoiceStatus: ARInvoiceStatus;
  invoiceDueDate?: Date | null;
  invoiceType?: InvoiceType | null;
  description?: string | null;
  adjustAmount?: number | null;
  balance?: number | null;
  memo?: string | null;
  aging?: AgingInfo | null;
  serviceType?: SERVICE_TYPE | null;
  isRush?: boolean | null;
  contactName?: string | null;
  isFailedTransaction?: boolean;
}

export interface AccountsReceivableResponse {
  data: AccountsReceivableInvoice[];
  invoiceNumbers?: string[];
  totalAmountDue?: string;
  lessThan30DaysDue?: string;
  past30DaysDue?: string;
  past60DaysDue?: string;
  past90DaysDue?: string;
  currentWeekDue?: string;
  totalRows: number;
  totalPages: number;
  currentPage: number;
}

export type FilterOption = {
  value: string;
  label1: string;
  label2: string;
};

export type AccountsReceivableFilterOptionsResponse = {
  clients: FilterOption[];
  invoiceNumbers: FilterOption[];
  fileNumbers: FilterOption[];
};
